module.exports = __webpack_public_path__ + "img/left-arrow-disabled.566a606b.svg";